import React, { useState } from "react";
import Layout from "../../../components/layout/Layout";
import {
  Link,
  useParams,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { ChevronLeftIcon } from "@heroicons/react/solid";
import EmployeeSalaryList from "./EmployeeSalaryList";
import EmployeeCTCDetail from "./EmployeeCTCDetail";
import BreadCrumbs from "../../../components/ui/BreadCrumbs";
import LinkButton from "../../../components/ui/LinkButton";
import { Button } from "../../../components/ui";

const SingleEmployeeSalary = () => {
  const navigate = useNavigate();
  const { id, username } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const source = searchParams.get("source");
  const changeType = (type) => {
    setSearchParams({ type, source: source || "" });
  };
  const [employeeType, setEmployeeType] = useState("");
  const fetchEmployeeType = (type) => {
    setEmployeeType(type);
  };

  // Dynamically set breadcrumbs based on source
  let breadcrumbs;
  if (source === "salary") {
    breadcrumbs = [
      { label: "Home", link: "/" },
      { label: "Salary", link: "/salary" },
      { label: "Salary Details", link: "" },
    ];
  } else if (source === "provident-fund") {
    breadcrumbs = [
      { label: "Salary", link: "/salary" },
      { label: "Provident Fund", link: "/provident-fund" },
      { label: "Salary Details", link: "" },
    ];
  } else if (source === "esic") {
    breadcrumbs = [
      { label: "Salary", link: "/salary" },
      { label: "ESIC", link: "/esic" },
      { label: "Salary Details", link: "" },
    ];
  } else if (source === "professional-tax") {
    breadcrumbs = [
      { label: "Salary", link: "/salary" },
      { label: "Professional Tax", link: "/professional-tax" },
      { label: "Salary Details", link: "" },
    ];
  } else if (source === "employee-details") {
    breadcrumbs = [
      { label: "Employees", link: "/employee-details" },
      {
        label: "Employee Details",
        link: `/employee-details/${id}/${username}`,
      },
      { label: "Salary Details", link: "" },
    ];
  } else {
    breadcrumbs = [
      { label: "Employees", link: "/employee-details" },
      {
        label: "Employee Details",
        link: `/employee-details/${id}/${username}`,
      },
      { label: "Salary Details", link: "" },
    ];
  }

  return (
    <>
      <div className=" px-4 py-4 flex justify-between sticky bg-white top-16 shadow-lg z-40">
        <div className="flex items-center space-x-4">
          <h2 className="text-2xl font-semibold">
            Salary Details for {username}
          </h2>
        </div>
        <div className=" space-x-5">
          {/* <Link to={`/employee-promotion/${id}/${username}`} className='px-5 py-2 bg-blue-300 rounded font-semibold'>Employee Promotion</Link> */}
          <LinkButton
            to={`/employee-salary/${id}/${username}?employeeType=${employeeType}&source=${source}`}
            className="bg-yellow-300 text-dark font-semibold"
          >
            Add Salary Details
          </LinkButton>
        </div>
      </div>

      <div className="px-4 my-5">
        <BreadCrumbs crumbs={breadcrumbs} />
      </div>

      <div className="px-5 border-b border-gray-200 py-2 mt-10 mx-5">
        <ul className="flex items-center space-x-6 text-gray-600">
          <li
            className={`${
              (searchParams.get("type") === "current_type" ||
                !searchParams.get("type")) &&
              "active"
            }`}
          >
            <Button
              variant={"ghost"}
              onClick={() => changeType("current_type")}
            >
              Current CTC Details
            </Button>
          </li>
          <li
            className={`${
              searchParams.get("type") === "previous_type" && "active"
            }`}
          >
            <Button
              variant={"ghost"}
              onClick={() => changeType("previous_type")}
            >
              Previous CTC Details
            </Button>
          </li>
        </ul>
      </div>
      {(searchParams.get("type") === "current_type" ||
        !searchParams.get("type")) && (
        <EmployeeCTCDetail fetchEmployeeType={fetchEmployeeType} />
      )}
      {searchParams.get("type") === "previous_type" && <EmployeeSalaryList />}
    </>
  );
};

export default SingleEmployeeSalary;
